<template>
  <div class="proof-card grid-item">
    <div class="grid-item-container">
      <v-row dense>
        <v-col cols="6" class="pt-4 pl-4">
          <h5 class="color light-gray text-left">{{ proof.first_name }}</h5>
        </v-col>
        <v-col cols="6" class="pt-4 pr-4">
          <h5 class="color light-gray text-right">{{ proof.date_submitted | prettyDate }}</h5>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pt-4 pr-4">
          <h4 class="color light-gray text-center"></h4>
          <h6 class="color light-gray text-center">
            <span v-if="proof.email">{{ proof.email }}</span> <span v-if="proof.phone" class="ml-4"> {{ proof.phone }}</span>
          </h6>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12"> </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12">
          <v-img :src="proof.proof_image_url" cover :eager="true" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SwayOfferWebGiveAwayCard',

  props: {
    proof: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.proof-card {
  border: solid 1px #eee;
  border-radius: 10px;
}
</style>
